/************************************************************************************

* INFINITE OPTIONS: Swatch labels + uppercase fields

*************************************************************************************/

function l_infiniteOptionsWrapSwatchLabels() {
	document.querySelectorAll('.spb-productoptionswatchwrapper').forEach((wrapper) => {
		Array.from(wrapper.childNodes)
			.filter((node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim())
			.forEach((textNode) => {
				const span = document.createElement('span')
				span.className = 'spb-swatchlabel'
				textNode.parentNode.insertBefore(span, textNode)
				span.appendChild(textNode)
			})
	})
}

function l_infiniteOptionsBindUppercase() {
	document
		.querySelectorAll(
			'#infiniteoptions-container .uppercase-option-set textarea, #infiniteoptions-container .uppercase-option-set input[type="text"]'
		)
		.forEach((field) => {
			if (field.dataset.lUppercaseBound === 'true') return
			field.dataset.lUppercaseBound = 'true'
			field.addEventListener('keyup', function () {
				this.value = this.value.toUpperCase()
			})
		})
}

function l_infiniteOptionsEnhance() {
	l_infiniteOptionsWrapSwatchLabels()
	l_infiniteOptionsBindUppercase()
}

function l_infiniteOptionsOnAppLoad() {
	l_infiniteOptionsEnhance()
}

if (window.__ioAppLoaded) {
	l_infiniteOptionsOnAppLoad()
}
document.addEventListener('infiniteoptions:appload', l_infiniteOptionsOnAppLoad)

// Safety net when beforeReady / appLoad is missed (CMP / script-order race)
;(() => {
	let scheduled = false
	const observer = new MutationObserver(() => {
		if (scheduled) return
		scheduled = true
		requestAnimationFrame(() => {
			scheduled = false
			l_infiniteOptionsEnhance()
		})
	})

	function observeContainer() {
		const container = document.getElementById('infiniteoptions-container')
		if (!container) return false
		observer.observe(container, { childList: true, subtree: true })
		l_infiniteOptionsEnhance()
		return true
	}

	let attempts = 0
	const poll = setInterval(() => {
		attempts += 1
		if (observeContainer() || attempts >= 40) {
			clearInterval(poll)
		}
	}, 250)
})()

/************************************************************************************

* CUSTOMIZE FUNCTION: Customize add-on price

*************************************************************************************/

document.addEventListener('DOMContentLoaded', () => {
	const productBlocksEl = document.querySelector('.product-single__meta')
	if (!productBlocksEl) return

	function l_infiniteOptionUpdatePrices() {
		// Helper to query element and optionally throw for missing element
		const getEl = (selector) => document.querySelector(selector)

		const infiniteoptionsPriceContainerEl = getEl('.infiniteoptions-price')

		if (!infiniteoptionsPriceContainerEl) return

		const infiniteoptionsPriceEl = infiniteoptionsPriceContainerEl.querySelector('.price-item.price-item--regular')
		const currentVariantPriceEl = getEl('.product-block.product-block--price')

		if (!infiniteoptionsPriceEl || !currentVariantPriceEl) return

		infiniteoptionsPriceContainerEl.classList.add('l-hidden')

		// Parse prices
		const infiniteoptionsPrice = l_parseMoneyToCents(infiniteoptionsPriceEl.textContent.trim())
		const currentVariantPrice = l_parseMoneyToCents(currentVariantPriceEl.textContent)

		// Compute add-on price
		const addOnPrice = infiniteoptionsPrice - currentVariantPrice

		// Query all price elements together
		const priceEls = {
			plus: document.getElementById('productPricePlus'),
			addOn: document.getElementById('productPriceAddOn'),
			equal: document.getElementById('productPriceEqual'),
			total: document.getElementById('productPriceTotal'),
		}

		// Remove hidden class and update content for available elements
		Object.values(priceEls).forEach((el) => {
			if (el) el.classList.remove('l-hidden')
		})

		if (priceEls.addOn) {
			priceEls.addOn.textContent = l_formatMoney(addOnPrice)
		}
		if (priceEls.total) {
			priceEls.total.textContent = infiniteoptionsPriceEl.textContent.trim()
		}
	}

	productBlocksEl.addEventListener('change', () => {
		const delayTimes = [1500, 2000]

		delayTimes.forEach((delay) => {
			l_debounce(() => {
				l_infiniteOptionUpdatePrices()
			}, delay)()
		})
	})

	document.addEventListener('variant:change', function (event) {
		const delayTimes = [1500, 2000]

		delayTimes.forEach((delay) => {
			l_debounce(() => {
				l_infiniteOptionUpdatePrices()
			}, delay)()
		})
	})
})
